module.exports = __webpack_public_path__ + "static/media/barbeque_grill.498dbd50.svg";